import { InstructionAttribute } from '../../../components/script-editor/tools/types';
import { NameScript } from '../../../configs/instructionConfig';

import { Project } from '../../../types/items';

type Params = {
  project: Project | null;
};

class NameScriptTooltip {
  static getTooltip(instructionElement: HTMLElement, params: Params) {
    const { project } = params;
    const data = instructionElement.getAttribute(InstructionAttribute.data);
    if (data && project) {
      const nameId = Number(data);
      if (NameScript[nameId]) {
        switch (nameId) {
          default:
            return null;
          case 0:
            return `Name in script: ${project.ref.user_owner.first_name}`;
          case 1:
            return `Name in script: ${project.ref.user_owner.full_name_first_last}`;
          case 2:
            return `Name in script: ${project.ref.organization?.common_name || 'Error: no organization specified'}`;
        }
      }
    }
    return null;
  }
}

export default NameScriptTooltip;
